<template>
  <div v-if="$route.name === 'EXCMTaskCreate'">
    <router-link
      :to="{ name: 'EXCMTaskList' }"
      class="btn btn-sm btn-default float-right">
      {{$t('buttons.backToList')}}
    </router-link>
    <b-card>
      <EXCMTaskForm
        :handle-update-field="updateField"
        :values="item"
        :errors="violations"
        @handleSubmit="onSendForm($event)"
      />
    </b-card>
  </div>
  <div v-else>
    <EXCMTaskForm
      @handleSubmit="onSendForm($event)"
      :handle-update-field="updateField"
      :values="item"
      :idCase="caseIri"
      :add-task-without-finish="addTaskWithoutFinish"
      :errors="violations" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMTaskForm from './Form'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission } from '@/utils/checkRoles.js'

const { mapGetters, mapActions } = createNamespacedHelpers('excmtask/create')

export default {
  components: {
    EXCMTaskForm
  },

  props: {
    caseIri: {
      type: String,
      default: null
    },
    addTaskWithoutFinish: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      routeName: null,
      item: {
        idCase: '',
        customFields: [],
        addTaskWithoutFinish: this.addTaskWithoutFinish
      }
    }
  },

  beforeCreate () {
    checkPagePermission('tasks', 'EXCMTaskCreate')
  },

  created () {
    this.routeName = this.$route.name
  },

  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm (item) {
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
